export const messages = {
  ourDomainExpertise: "Our Domain Expertise",
};
